import { MatchEventFragmentFragment } from '../../../generated/graphql';

export type CardEventType = 'GREEN_CARD' | 'YELLOW_CARD' | 'RED_CARD';

export const CARD_EVENTS: CardEventType[] = [
  'GREEN_CARD',
  'YELLOW_CARD',
  'RED_CARD',
];

export const cardEventNameLookup: Record<CardEventType, string> = {
  GREEN_CARD: 'Green card',
  YELLOW_CARD: 'Yellow card',
  RED_CARD: 'Red card',
};

export const getCardName = (type: CardEventType) => cardEventNameLookup[type];

export interface CardMatchEventFragment extends MatchEventFragmentFragment {
  event: CardEventType;
}

export interface ScorerEventFragment extends MatchEventFragmentFragment {
  event: 'GOAL_SCORED';
}

export interface AssistEventFragment extends MatchEventFragmentFragment {
  event: 'ASSIST';
}

export const isCardEvent = (
  e: MatchEventFragmentFragment,
): e is CardMatchEventFragment => CARD_EVENTS.some((ce) => ce === e.event);

export const isScorerEvent = (
  e: MatchEventFragmentFragment,
): e is ScorerEventFragment => e.event === 'GOAL_SCORED';

export const isAssistEvent = (
  e: MatchEventFragmentFragment,
): e is AssistEventFragment => e.event === 'ASSIST';
